import { useContext, useEffect } from 'react'
import styles from './Layout.module.css'
import { AppStateContext } from '../../state/AppProvider'
import SidebarMenu from '../../components/SidebarMenu/SidebarMenu'
import { Header } from '../../components/Header/Header'
import { Outlet } from 'react-router-dom'
import { CosmosDBStatus, UIEnv } from '../../api'
import { useSidebarContext } from '../../state/SidebarProvider'
import { ChatHistoryPanel } from '../../components/ChatHistory/ChatHistoryPanel'
import CitationPanel from '../../components/CitationPanel/CitationPanel'
import { MessageBarComponent } from '../../components/MessageBar/MessageBar'

const Layout = () => {
  const appStateContext = useContext(AppStateContext)
  const isChatHistoryOpen = appStateContext?.state.isChatHistoryOpen || false
  const ui = appStateContext?.state?.frontendSettings?.ui
  const { isExpanded, closeSidebar } = useSidebarContext()

  useEffect(() => { }, [appStateContext?.state.isCosmosDBAvailable.status])

  const handleOverlayClick = () => {
    if (isExpanded) {
      closeSidebar()
    }
    if (isChatHistoryOpen) {
      appStateContext?.dispatch({ type: 'TOGGLE_CHAT_HISTORY' })
    }
  }

  return (
    <div className={styles.layout}>
      <SidebarMenu />
      {appStateContext?.state.isChatHistoryOpen &&
        appStateContext?.state.isCosmosDBAvailable?.status !== CosmosDBStatus.NotConfigured && ui?.show_chat_history_button !== false && <ChatHistoryPanel />}
      <div className={styles.content}>
        <div onClick={handleOverlayClick} className={isExpanded || isChatHistoryOpen ? styles.overlay : ''}></div>
        <Header />
        {(ui?.env === UIEnv.DEV || ui?.env === UIEnv.STG) && <MessageBarComponent />}
        <Outlet />
      </div>
      <CitationPanel />
    </div>
  )
}

export default Layout
